// extracted by mini-css-extract-plugin
module.exports = {"container":"Copyright_container__NQAl9","copyright":"Copyright_copyright__23gHt"};